export enum BackendType {
  AUTH = 'auth',
  CORE = 'core',
  MESSAGE = 'message',
  FILE = 'file',
}
